/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateOrganizationPaymentCurrentPlanResponseData,
  UpdateOrganizationPaymentCurrentPlanResponseDataFromJSON,
  UpdateOrganizationPaymentCurrentPlanResponseDataFromJSONTyped,
  UpdateOrganizationPaymentCurrentPlanResponseDataToJSON
} from './UpdateOrganizationPaymentCurrentPlanResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationPaymentCurrentPlanResponse
 */
export interface UpdateOrganizationPaymentCurrentPlanResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationPaymentCurrentPlanResponse
   */
  status: number
  /**
   *
   * @type {UpdateOrganizationPaymentCurrentPlanResponseData}
   * @memberof UpdateOrganizationPaymentCurrentPlanResponse
   */
  data: UpdateOrganizationPaymentCurrentPlanResponseData
}

export function UpdateOrganizationPaymentCurrentPlanResponseFromJSON(
  json: any
): UpdateOrganizationPaymentCurrentPlanResponse {
  return UpdateOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationPaymentCurrentPlanResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationPaymentCurrentPlanResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: UpdateOrganizationPaymentCurrentPlanResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationPaymentCurrentPlanResponseToJSON(
  value?: UpdateOrganizationPaymentCurrentPlanResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: UpdateOrganizationPaymentCurrentPlanResponseDataToJSON(value.data)
  }
}
